import { Button, Modal } from "antd";
import React, { useState } from "react";
import { DBCompHeading } from "../../../Styles";
import "../../../Styles.css";
import AddExpence from "./Add Expense Form/AddExpence";
import ApplyClaimTable from "./Table/Table";

export default function ApplyClaim() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCallback = (childData: boolean) => {
    setIsModalVisible(childData);
  };

  return (
    <div>
      <DBCompHeading>Apply Claim</DBCompHeading>
      <Button type="primary" className="AppNExp" onClick={showModal}>
        Apply New Expense
      </Button>
      <Modal
        title="Add Expense Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        width={830}
      >
        <AddExpence parentCallback={handleCallback} />
      </Modal>
      <ApplyClaimTable />
    </div>
  );
}
